import ZoneKeyCreator from './ZoneKeyCreator';
import {
    blankKeyText,
    unassignedLoadZoneText,
} from '../../../constants/gridText';

const LoadZoneKeyCreator = (params) => {
    const key = ZoneKeyCreator(params);
    return key === blankKeyText ? unassignedLoadZoneText : key;
};

export default LoadZoneKeyCreator;
